import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';

type FilterAction = {
  type: string,
  filters?: {
    fieldId: string,
    content: string,
  },
};

const initialState = {};

export default function reduceFilter(state = initialState, action: FilterAction) {
  if (!action.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);

  const inProgressState = {
    ...state?.appliedFilters ?? {},
    ...state?.inProgress ?? {},
  };

  const removeSingleFilter = (
    stateArray,
    toRemove,
  ) => (stateArray ?? []).filter(
    // eslint-disable-next-line no-nested-ternary
    (item) => (item?.name ? item?.name !== toRemove
      : (item?.value ? item?.value !== toRemove : item !== toRemove)),
  );

  switch (action?.type) {
  case ActionTypes.discover.postFilters.START:
  case ActionTypes.admin.talentFilters.START:
    return {
      ...state,
      [actionGroup]: {
        fetching: true,
        success: false,
        error: null,
      },
    };

  case ActionTypes.discover.postFilters.SUCCESS:
  case ActionTypes.admin.talentFilters.SUCCESS:
    return {
      ...state,
      appliedFilters: { ...state?.inProgress },
      inProgress: {},
      [actionGroup]: {
        fetching: false,
        success: true,
        error: null,
      },
    };

  case ActionTypes.discover.postFilters.ERROR:
  case ActionTypes.admin.talentFilters.ERROR:
    return {
      ...state,
      [actionGroup]: {
        fetching: false,
        success: false,
        error: action?.error,
      },
    };

  case ActionTypes.filters.add: {
    return {
      ...state,
      inProgress: {
        ...inProgressState,
        [action?.filters?.fieldId]: (
          (inProgressState ?? {})[action?.filters?.fieldId] ?? [])
          .concat(action?.filters?.content),
      },
    };
  }

  case ActionTypes.filters.remove:
    return {
      ...state,
      ...action?.removeFromApplied && {
        appliedFilters: {
          ...state?.appliedFilters ?? {},
          [action?.filters?.fieldId]: removeSingleFilter(
            (state?.appliedFilters ?? {})[action?.filters?.fieldId] ?? [], action?.filters?.content,
          ),
        },
      },
      ...!action?.removeFromApplied && {
        inProgress: {
          ...inProgressState,
          [action?.filters?.fieldId]: removeSingleFilter(
            (inProgressState ?? {})[action?.filters?.fieldId] ?? [], action?.filters?.content,
          ),
        },
      },
    };

  case ActionTypes.filters.removeInProgress:
    return {
      ...state,
      inProgress: {},
    };

  case ActionTypes.filters.removeAll:
    return initialState;

  case ActionTypes.filters.get:
  default:
    return state;
  }
}
